import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSessionData } from '@/services';
import en from './en';
import es from './es';
import pt from './pt';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const session = getSessionData();

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: session?.lng || 'pt',
  resources: { en, es, pt },
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
